import React, { useEffect, useRef, useState } from "react";
import { Award, Users, Heart } from "lucide-react";

const Stats = () => {
  const stats = [
    { icon: <Award className="w-8 h-8 text-blue-600" />, number: 120, label: "مشروع منجز" },
    { icon: <Users className="w-8 h-8 text-blue-600" />, number: 80, label: "عملاء راضون" },
    { icon: <Heart className="w-8 h-8 text-blue-600" />, number: 5, label: "سنوات خبرة" },
  ];

  const refs = useRef([]);
  const sectionRef = useRef(null);
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated) {
            setHasAnimated(true);
            
            refs.current.forEach((ref, idx) => {
              if (!ref) return;
              
              let start = 0;
              const end = stats[idx].number;
              const duration = 2000;
              const increment = end / (duration / 16); // 60fps
              
              const animate = () => {
                start += increment;
                if (start < end) {
                  ref.innerText = Math.floor(start) + "+";
                  requestAnimationFrame(animate);
                } else {
                  ref.innerText = end + "+";
                }
              };
              
              animate();
            });
          }
        });
      },
      { threshold: 0.3 } // يبدأ العد عندما يظهر 30% من القسم
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [hasAnimated]);

  return (
    <section className="bg-white py-16" id="stats" ref={sectionRef}>
      <div className="container mx-auto px-6 text-center">
        <div className="grid md:grid-cols-3 gap-8">
          {stats.map((item, index) => (
            <div
              key={index}
              className="p-6 bg-gray-50 rounded-xl shadow hover:scale-105 transition-transform duration-300 cursor-pointer"
            >
              <div className="flex justify-center mb-2">{item.icon}</div>
              <h3
                className="text-3xl font-bold text-gray-900"
                ref={(el) => (refs.current[index] = el)}
              >
                0+
              </h3>
              <p className="text-gray-600">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;